// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 500ms ease-out;
  overflow: auto;
  z-index: 10;
  background: #FFDF00;
  text-align: center;
}
.sidebar::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: transparent;
}
.sidebar::-webkit-scrollbar-thumb {
  background-color: #e1e6ec;
  border-radius: 8px;
}
.sidebar.opened {
  opacity: 1;
  pointer-events: auto;
  z-index: 999999999;
}
.sidebar__list {
  margin-top: 40px;
}
.sidebar__list__item {
  border-bottom: 2px solid transparent;
}
.sidebar__list__item:last-child {
  border-bottom: 0;
}
.sidebar__list__item .nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  min-height: 48px;
  transition: background-color 0.2s ease-out;
  position: relative;
}
.sidebar__list__item .nav-item h4 {
  font-weight: 500;
}
.sidebar__list__item .nav-item h4 + .heading-3 {
  color: #142529;
}
.sidebar .content-body {
  padding: 0 12px;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: normal;
}
.sidebar .content-body nav {
  margin: auto;
}
.sidebar__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  min-height: var(--headerHeight);
  padding: 4px 12px 4px 16px;
}
.sidebar__content .description {
  max-width: 222px;
}
.sidebar__content a {
  font-size: 10px;
}
.sidebar__content img {
  position: relative;
  top: 1px;
  max-width: 100%;
  width: 161px;
  aspect-ratio: auto 161/44;
}
@media screen and (max-width: 486px) {
  .sidebar img {
    top: 1.8px;
  }
}
@media screen and (min-width: 486px) {
  .sidebar img {
    top: 1px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/Sidebar/Sidebar.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EAEA,WAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,kCAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAAF;ACqDE;EACE,UDrDiB;ECsDjB,WDtDsB;ECuDtB,6BAAA;ADnDJ;ACsDE;EACE,yBAAA;EACA,kBAAA;ADpDJ;AANE;EACE,UAAA;EACA,oBAAA;EACA,kBAAA;AAQJ;AALE;EAGE,gBAAA;AAKJ;AAJI;EAEE,oCAAA;AAKN;AAJM;EACE,gBAAA;AAMR;AAJM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;AAMR;AALQ;EACE,gBAAA;AAOV;AANU;EACE,cAAA;AAQZ;AAEE;EACE,eAAA;EACA,WAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAEI;EACE,YAAA;AAAN;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,+BAAA;EACA,0BAAA;AADJ;AAEI;EACE,gBAAA;AAAN;AAEI;EACE,eAAA;AAAN;AAEI;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AAAN;AClEI;EDuEA;IACE,UAAA;EAFJ;AACF;ACvEI;ED4EA;IACE,QAAA;EAFJ;AACF","sourcesContent":["@import \"src/assets/styles/variables\";\n\n.sidebar {\n  position: fixed;\n  //position: absolute;\n  width: 100%;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 500ms ease-out;\n  overflow: auto;\n  z-index: 10;\n  background: #FFDF00;\n  text-align: center;\n  @include scrollBar(3px, 3px);\n\n  &.opened {\n    opacity: 1;\n    pointer-events: auto;\n    z-index: 999999999;\n  }\n\n  &__list {\n    //border-radius: 16px;\n    //background: rgba(255, 255, 255, 0.35);\n    margin-top: 40px;\n    &__item {\n      //border-bottom: 2px solid rgba(35, 58, 64, 0.10);\n      border-bottom: 2px solid transparent;\n      &:last-child{\n        border-bottom: 0;\n      }\n      .nav-item {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 16px 0;\n        min-height: 48px;\n        transition: background-color .2s ease-out;\n        position: relative;\n        h4{\n          font-weight: 500;\n          + .heading-3{\n            color: #142529;\n          }\n        }\n\n        &:hover, &.active {\n          //background-color: #F3F3FA;\n        }\n      }\n    }\n  }\n  .content-body{\n    padding: 0 12px;\n    height: 60%;\n\n    display: flex;\n    flex-direction: column;\n    align-items: normal;\n    nav{\n      margin: auto;\n    }\n  }\n  &__content{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 24px;\n    min-height: var(--headerHeight);\n    padding: 4px 12px 4px 16px;\n    .description{\n      max-width: 222px;\n    }\n    a{\n      font-size: 10px;\n    }\n    img{\n      position: relative;\n      top: 1px;\n      max-width: 100%;\n      width: 161px;\n      aspect-ratio: auto 161 / 44;\n    }\n  }\n\n  @include screen(xs, max) {\n    img {\n      top: 1.8px;\n    }\n  }\n  @include screen(xs, min) {\n    img {\n      top: 1px;\n    }\n  }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap');\n\n@import \"color-variables\";\n\n$intel: 'Inter', sans-serif;\n$montserrat: 'Montserrat', sans-serif;\n$sfCompact: 'SF-Compact', sans-serif;\n$brutalType: 'BrutalType', sans-serif;\n\n// BREAKPOINTS\n$media-xs: 486px;\n$media-sm: 768px;\n$media-md: 1024px;\n$media-lg: 1200px;\n$media-xl: 1440px;\n\n@mixin screen($size, $type: min, $pixels: $media-xs) {\n  @if $size == \"xs\" {\n    @media screen and ($type + -width: $media-xs) {\n      @content;\n    }\n  } @else if $size == \"sm\" {\n    @media screen and ($type + -width: $media-sm) {\n      @content;\n    }\n  } @else if $size == \"md\" {\n    @media screen and ($type + -width: $media-md) {\n      @content;\n    }\n  } @else if $size == \"lg\" {\n    @media screen and ($type + -width: $media-lg) {\n      @content;\n    }\n  } @else if $size == \"xlg\" {\n    @media screen and ($type + -width: $media-xl) {\n      @content;\n    }\n  } @else if $size == \"custom\" {\n    @media screen and ($type + -width: $pixels + px) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n//BETWEEN BREAKPOINTS\n@mixin media-breakpoint-between($minW, $maxW) {\n  @media screen and (min-width: $minW - 1px) and (max-width: $maxW) {\n    @content;\n  }\n}\n\n@mixin fontVariation($size: \"16px\", $weight: \"500\", $lineHeight: \"20px\") {\n  font-size: $size;\n  line-height: $weight;\n  font-weight: $lineHeight;\n}\n\n@mixin lineClamp($line) {\n  display: -webkit-box;\n  -webkit-line-clamp: #{$line};\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin scrollBar($width, $height) {\n  &::-webkit-scrollbar {\n    width: $width;\n    height: $height;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #e1e6ec;\n    border-radius: 8px;\n  }\n}\n\n%positioned {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n}\n\n%flex-centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
